export const dropdownSlide = {
	init: function() {
		this.slideDropdownBtn = document.querySelectorAll('[data-dropdown="button"]');
		this.faqWrapper = document.querySelector('.faq-section__dropdowns-wrapper');
		this.assignEventListeners();
		this.checkDescriptonHeight();
	},

	assignEventListeners: function() {
		[].slice.call(this.slideDropdownBtn).forEach((btn)=> {
			btn.addEventListener('click', _=> {
				this.slideDropdownContent(btn);
			})
		});
	},

	slideDropdownContent: function(clickedBtn) {
		const dropdownContent = clickedBtn.nextElementSibling,
			  arrow = clickedBtn.querySelector('.resellers-dropdown__arrow-icon'),
			  dropdownContentHeight = this.getWrapperHeight(dropdownContent);

		if (dropdownContent.clientHeight > 0) {
			requestAnimationFrame(() => {
				dropdownContent.style.height = dropdownContentHeight + 'px';
				requestAnimationFrame(() => {
				  dropdownContent.style.height = 0;
				});
			});
			clickedBtn.classList.remove('active');
		} else {
			dropdownContent.style.height = dropdownContentHeight + 'px';
			clickedBtn.classList.add('active');
		}

		if (clickedBtn.hasAttribute('data-nested') && window.innerWidth < 768) {
			const faqWrapper = clickedBtn.closest('.faq-section__dropdowns-wrapper');
			faqWrapper.style.height = 'auto';
		}
	},

	getWrapperHeight: function(element) {
		return [].slice.call(element.children).map(elem => this.calculateOuterHeight(elem)).reduce((a, b) => a + b, 0);
	},

	calculateOuterHeight: function(el) {
		const style = getComputedStyle(el);
		let height = el.offsetHeight;

		height += parseInt(style.marginTop) + parseInt(style.marginBottom);
		return height;
	},

	checkDescriptonHeight: function() {
		if (window.innerWidth < 1024) return;
		const descriptionBlock = document.querySelector('.product-info-container');
		if (!descriptionBlock) return;
		const productPriceSection = document.querySelector('.product-price-section'),
			  descriptionSectionHeight = descriptionBlock.offsetHeight;
		if (document.querySelector('main').dataset.page === 'product-page-no-product') {
			const pricePosition = this.getElementsPosition(productPriceSection),
				  descPosition = this.getElementsPosition(descriptionBlock);
			if (pricePosition > descPosition) {
				descriptionBlock.style.height = descriptionSectionHeight + pricePosition - descPosition + 'px';
			}
		} else {
			const resellersDropdown = document.querySelector('.resellers-dropdown__menu');
			if (!resellersDropdown) return;
			resellersDropdown.addEventListener('click', _=> {
				const pricePosition = this.getElementsPosition(productPriceSection) + 540,
					  descPosition = this.getElementsPosition(descriptionBlock);
				if (pricePosition > descPosition) {
					if (resellersDropdown.classList.contains('active')) {
						descriptionBlock.style.minHeight = descriptionSectionHeight + pricePosition - descPosition + 20 + 'px';
					} else {
						descriptionBlock.style.minHeight = descriptionSectionHeight + 'px';
					}
				}
			});
		}
	},

	getElementsPosition: function(el) {
		const bodyRect = document.body.getBoundingClientRect(),
			  elRect = el.getBoundingClientRect();
		return elRect.bottom - bodyRect.top;
	}
}
